import { render, staticRenderFns } from "./RenShi2.vue?vue&type=template&id=3de1a68d&scoped=true&"
import script from "./RenShi2.vue?vue&type=script&lang=js&"
export * from "./RenShi2.vue?vue&type=script&lang=js&"
import style0 from "./RenShi2.vue?vue&type=style&index=0&id=3de1a68d&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3de1a68d",
  null
  
)

export default component.exports